import { gql } from "@apollo/client";
import { SELECT_OPTION_FIELDS } from "graphql/types/SelectOptionType";

export const LIST_ALL_DSP_OPTIONS = gql`
    query ListAllDspOptions {
        allOptions: listAllDspOptions {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;
